module.exports = __webpack_public_path__ + "img/flat.a0c201bf.png";